module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch1",
      "id": "rch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('b', [_vm._v("RECRUITING THE VOLUNTEERS, 1861")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("n the night of February 15, 1861, nearly two months before Fort Sumter and the opening of the Civil War, a thousand Texas volunteers secretly assembled at Sea Willow Creek, a few miles north of San Antonio. They had been called to arms by Ben McCulloch, colonel of cavalry in the newly formed Army of Texas, for the purpose of capturing the historic Alamo, then a storehouse for arms and military supplies under the command of General David E. Twiggs, United States Army.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The excited soldiers had gathered in small groups beneath the trees, and the noise of the meeting was compounded of men’s voices, squeaking saddles, and the high-pitched whinny of horses. Mist from the creek curled through the bivouac. Soon there was a drizzle of cold rain. At midnight McCulloch rode into camp and quickly outlined to the men his plan of attack. They were to surround the Alamo and wait for the command to open fire."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt1ch1",
      "id": "rnt1ch1"
    }
  }, [_vm._v("1")])])]), _vm._v(" This was typical of the way McCulloch fought. His plans and preparations were clear and simple, his manner confident.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _vm._v("McCulloch had won fame by the storming of the Obispado during the Mexican War and for his daring and heroic feats as a Texas Ranger. A “thin, spare man, of great muscle and activity,” a tireless fighter and an excellent cavalryman, he enjoyed the admiration and respect of citizens and soldiers alike."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt2ch1",
      "id": "rnt2ch1"
    }
  }, [_vm._v("2")])])]), _vm._v(" “The name of Ben McCulloch,” wrote the editor of one Arkansas paper, “wherever it is known, is a guarantee of itself.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt3ch1",
      "id": "rnt3ch1"
    }
  }, [_vm._v("3")])])]), _vm._v(" The affair about to commence at San Antonio would more firmly establish the name of Ben McCulloch (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 1")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The rain stopped presently, and through the long, quiet hours of early morning, the Texans sat beside campfires, cleaning their weapons and waiting for what they expected would be a good fight. The biting February wind caused them much discomfort. Some had coats, others were in shirt sleeves, and a few were wrapped in saddle blankets and old shawls. With the first rays of the sun came the order to move, and the eager troops filed quietly into town. They crept through the morning shadows of the buildings and took positions on the roofs of stores encircling the Alamo."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt4ch1",
      "id": "rnt4ch1"
    }
  }, [_vm._v("4")])])]), _vm._v(" Inside the fortress, the Federals watched the stealthy movements of the blurred figures. The commander in charge, thinking the situation hopeless, surrendered the stockade to McCulloch without the firing of a shot."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt5ch1",
      "id": "rnt5ch1"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("As the United States flag was lowered from above the old Alamo, the Texans whooped and shouted and, waving their weapons above their heads, ran to the Grand Plaza, where they celebrated the first victory of Southern cavalry in the Trans-Mississippi.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("When agents of the state took charge of the Alamo on February 19, 1861, the services of the volunteers were no longer needed and they disbanded to return to their homes."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt6ch1",
      "id": "rnt6ch1"
    }
  }, [_vm._v("6")])])]), _vm._v(" Many of them, including their distinguished commander, would join the Confederate Army in the months that followed.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("Shortly after the capture of the Alamo, the Texas Committee of Public Safety"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt7ch1",
      "id": "rnt7ch1"
    }
  }, [_vm._v("7")])])]), _vm._v(" authorized Colonel Henry E. McCulloch (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 1")]), _vm._v("), brother of Ben McCulloch, and John S. “Rip” Ford (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 11")]), _vm._v(") to raise two regiments of volunteer cavalry for the Army of Texas. Their instructions were to capture Federal property and munitions for the state. Henry McCulloch gathered his volunteers in the Austin-San Antonio area. On February 20, after the men were fully mounted, they rode into northern Texas to capture Camp Colorado, Fort Chadbourne, Camp Cooper, and Fort Belknap. Colonel McCulloch then obtained a commission in the Confederate Army and set about raising additional companies for his cavalry regiment. On April 15, 1861, ten full companies from Bexar, Travis, Gonzales, and contiguous counties organized as the First McCulloch Texas Mounted Rifles, the first cavalry outfit from Texas to enter the Confederate service."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt8ch1",
      "id": "rnt8ch1"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("While Henry E. McCulloch recruited in the San Antonio area, Rip Ford set up headquarters in Houston and appealed to loyal “Texians” to join his regiment. By February 18 he had 500 eager volunteers in six companies."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt9ch1",
      "id": "rnt9ch1"
    }
  }, [_vm._v("9")])])]), _vm._v(" At dawn the next day, the troops marched to Galveston, boarded the steamer "), _c('i', [_vm._v("General Rusk")]), _vm._v(" and the schooner "), _c('i', [_vm._v("Shark")]), _vm._v(" and sailed down the coast to the island Brazos de Santiago, a United States stronghold several miles above Brownsville. Hoping for a fight, the Texans stormed ashore on February 21 to find only twelve defenders who struck their colors immediately and surrendered the island without bloodshed. The victorious Southerners then converged on the parade grounds to shout and wave their rifles as the Lone Star Flag was run up the flagpole to the boom of a fifteen-gun salute."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt10ch1",
      "id": "rnt10ch1"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fig1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/maps#fig1",
      "id": "rfig1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE")]), _vm._v(" 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("On February 22 Ford left Lieutenant Colonel Hugh McLeod in command of the island and went to the mainland to negotiate with the United States force that held Fort Brown just below Brownsville. After some difficulty, the colonel reached an understanding with the Union commander, who agreed to surrender to the Texans all the United States forts from Brownsville to El Paso."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt11ch1",
      "id": "rnt11ch1"
    }
  }, [_vm._v("11")])])]), _vm._v(" Texan troops then marched northwest along the Rio Grande to occupy Fort McIntosh, Camp Wood, Fort Inge, Fort Clark, Fort Lancaster, Camp Stockton, Fort Davis, and Fort Bliss. On May 23 Ford’s outfit, now numbering 1,200 men, was sworn into Confederate service by order of the governor and was designated the Second Texas Cavalry."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt12ch1",
      "id": "rnt12ch1"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Rip Ford was enthusiastic over the achievement of his Texan volunteers. Wearing huge wheel spurs and high black hats ornamented with the beloved Lone Star and armed with six-shooters and bowie knives, they were fearless horsemen. Texas should feel proud of them."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt13ch1",
      "id": "rnt13ch1"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Ford’s and Henry E. McCulloch’s regiments formed the nucleus of the Confederate cavalry in the Trans-Mississippi. During the rest of the year 1861 the War Department commissioned over twenty colonels to raise cavalry regiments in the region and to add them to this initial cavalry force. Most of these outfits were retained for service in the Trans-Mississippi, but some were transferred east of the River. In the absence of any over-all regional command throughout 1861, these units received their operational assignments from the War Department. The story of the recruiting of these volunteer cavalrymen in 1861 is one abounding with lively events, humor, and even tragedy.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("The first need for additional cavalry in Texas came about through the appearance of serious trouble on the northern border late in February. After the convention at Austin announced, on March 1, that Texas was no longer a state in the Union, Federal troops patrolling the area from Fort Mason to the Red River fled to Kansas. The settlers ranching and farming in the area were thus left to the mercy of small bands of savage Comanches, who soon began attacking isolated homesteads, burning fields, destroying buildings, and killing and scalping women and children. To raise troops to protect them, the state military board placed calls for volunteers in the newspapers and sent recruiters into various counties. Volunteers were to arm, equip, and mount themselves, and to bring enough provisions for six days."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt14ch1",
      "id": "rnt14ch1"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Among the recruiters chosen by the governor to raise companies for frontier service was A. W. Crawford, sheriff of Harrison County. Receiving the order on April 1, Crawford immediately set up headquarters in Marshall and rode around the area appealing for the citizens to take up arms."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt15ch1",
      "id": "rnt15ch1"
    }
  }, [_vm._v("15")])])]), _vm._v(" By April 10 the company was full, numbering 103 men. On muster day, April 19, wrote one member of the unit, “at an early hour the hitherto quiet of Marshall is disturbed by the ‘Neigh of the war horse,’ and the assembling of the Cavalry,” as bodies of rowdy recruits rode in from Panola, Upshur, and Marion counties. The men were well mounted and equipped for service, except for carbines and pistols, which were to be obtained later from Austin.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("The process of organizing the company took up the whole day. Horses were checked for fitness. The county judge swore each man into state service in the courthouse. And this done, the soldiers named their company the “W. P. Lane Rangers,” in honor of a distinguished citizen of Marshall, Major W. P. Lane, veteran of the Texas Revolution and the Mexican War. After elections were held, which made Sam Richardson captain,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt16ch1",
      "id": "rnt16ch1"
    }
  }, [_vm._v("16")])])]), _vm._v(" the Rangers sat rather restlessly through a parting sermon, delivered by the Reverend W. C. Dunlap of Marshall. Then laughing and shouting, they ran to the nearest bars to celebrate. They returned to camp much later, many of them “Half seas’ over” from a little too much celebrating.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("At dawn the next morning, the men broke camp and rode into Marshall. “Their spirited steeds,” recorded W. W. Heartsill, made “the streets … ring with their proud, defiant tread.” Townspeople turned out by the hundreds to cheer and yell at the soldiers. At about eight o’clock, a group of ladies congregated on the courthouse lawn and prepared to present a flag to the company. The troops moved to an empty field on the outskirts of town, fell in at parade formation, and then, riding four abreast, trotted into Marshall. At the public square they formed in a long, straight line in front of the circle of ladies and town officials. One of Marshall’s fair young women then presented the flag to Captain Richardson and made a short speech praising the heroic soldiers and lauding the Confederate cause.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("After the “trying time,” or “crying time”—the parting from relatives and friends—the company mounted, formed in columns, and proceeded to the college, where the men were presented with a “happy surprise”—a table “groaning beneath the load” of good things to eat, prepared by the ladies as “a parting remembrance.” Having gorged themselves, the soldiers regrouped, and midst shouts and whoops from the onlookers, rode out of town toward the west."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt17ch1",
      "id": "rnt17ch1"
    }
  }, [_vm._v("17")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("At Waco the company was given a military salute and escorted through the town by two companies of the Lone Star Guards."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt18ch1",
      "id": "rnt18ch1"
    }
  }, [_vm._v("18")])])]), _vm._v(" On May 8 the force reached San Antonio and then proceeded west to Earl Van Dorn’s cavalry camp on Leon Creek. There, on May 23, the Rangers were sworn into Confederate service by order of the governor. Shortly afterwards the outfit became Company F of Colonel John S. Ford’s Second Texas Cavalry. For the next year the Rangers served on the frontier, protecting settlers from the wild Comanches and performing general patrol duty."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt19ch1",
      "id": "rnt19ch1"
    }
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("A second crack cavalry outfit for frontier service came from the seventh and eighth military districts around Grayson County."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt20ch1",
      "id": "rnt20ch1"
    }
  }, [_vm._v("20")])])]), _vm._v(" Early in May, 1861, William C. Young, who had been a United States Marshall before the war, received authority from the governor to recruit volunteer horsemen. Young travelled through Grayson, Fannin, Hunt, and Collin counties seeking men. By mid-May he had ten full companies which organized as the Eleventh Texas Cavalry. The outfit crossed the Red River to capture Fort Arbuckle, Fort Washita, and Fort Cobb and afterwards rode through the Indian Territory negotiating with the Comanches, Kiowas, and Chickasaws."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt21ch1",
      "id": "rnt21ch1"
    }
  }, [_vm._v("21")])])]), _vm._v(" Later, in April, 1862, the regiment was transferred east of the Mississippi, where it became part of Joseph Wheeler’s celebrated cavalry corps."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt22ch1",
      "id": "rnt22ch1"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("Like the Eleventh Texas and the W. P. Lane Rangers, all other state organizations had by mid-May been transferred to Confederate service."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt23ch1",
      "id": "rnt23ch1"
    }
  }, [_vm._v("23")])])]), _vm._v(" In order to secure unity of command Governor Edward Clark had dissolved the state service and ordered all state organizations to be placed under the command of General Earl Van Dorn, a West Point graduate and nephew of Andrew Jackson, who had been appointed commander of the District of Texas. For the rest of the war, all regular cavalry regiments were raised for the Confederate Army to serve for three years or for the war."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt24ch1",
      "id": "rnt24ch1"
    }
  }, [_vm._v("24")])])]), _vm._v(" Recruiting was restricted to those officers holding commissions in the Confederate service, and the procedure used to raise troops was based on regulations prescribed by the War Department."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt25ch1",
      "id": "rnt25ch1"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("On May 13 the War Department ordered Ben McCulloch, now a brigadier general commanding the Indian Territory, to raise the first Confederate army in the Trans-Mississippi."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt26ch1",
      "id": "rnt26ch1"
    }
  }, [_vm._v("26")])])]), _vm._v(" From his headquarters at Fort Smith, Arkansas, McCulloch wrote recruiting officers in the region to complete the formation of their outfits as soon as possible and to march to Fort Smith."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt27ch1",
      "id": "rnt27ch1"
    }
  }, [_vm._v("27")])])]), _vm._v(" One of the major objectives of the force, McCulloch told them, was to check Federal advances in Missouri and perhaps even an invasion of Kansas. By August 4 McCulloch’s command had been joined by the First Arkansas Cavalry under Colonel DeRosey Carroll; the First Arkansas Mounted Rifles, Colonel James McIntosh; the Third Arkansas Infantry, Colonel John R. Gratiot; the Fourth Arkansas Infantry, Colonel J. D. Walker; the Fifth Arkansas Infantry, Colonel Tom P. Dockery; the Third Texas Cavalry (South Kansas-Texas Regiment), Colonel Elkanah Greer; the Third Louisiana Infantry, Colonel Louis Hébert; and Captains W. E. Woodruff’s and J. G. Reid’s Arkansas artillery batteries."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt28ch1",
      "id": "rnt28ch1"
    }
  }, [_vm._v("28")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Colonel DeRosey Carroll’s Arkansas state cavalry was the first of McCulloch’s mounted regiments to be raised. The colonel had started recruiting men back in April, shortly after state militia companies had made a surprise raid on the Federal stockade at Fort Smith. Carroll’s enrolling officers, working in Crawford and adjacent counties, had orders to rendezvous at Camp Walker after their companies were formed.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("The recruiting captain for Crawford County, Charles A. Carroll,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt29ch1",
      "id": "rnt29ch1"
    }
  }, [_vm._v("29")])])]), _vm._v(" had arrived in Van Buren on or about April 24 and had immediately placed a notice in the Van Buren "), _c('i', [_vm._v("Press")]), _vm._v(" calling for volunteers to join his new company. “Turn out,” he urged; “let the fires of seventy-six be rekindled—let us baptise the graves of our fathers in blood!”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt30ch1",
      "id": "rnt30ch1"
    }
  }, [_vm._v("30")])])]), _vm._v(" Newspapers in the area and community leaders encouraged volunteering, and Carroll himself travelled through Lee’s Creek Township, Oliver’s Store, Sim Coes, and Mountain Township seeking men."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt31ch1",
      "id": "rnt31ch1"
    }
  }, [_vm._v("31")])])]), _vm._v(" On May 6, the day that Arkansas formally left the Union, the last man necessary to make a full company (90 men) signed his name to Carroll’s roll. Twelve days later the unit assembled at Camp Vine Prairie, just outside Van Buren. The troops conducted an election of officers and chose Carroll their captain by unanimous vote."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt32ch1",
      "id": "rnt32ch1"
    }
  }, [_vm._v("32")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("After a week of drilling, the company broke camp and rode into Van Buren. The men paraded noisily around the courthouse square, executed a flashy military halt in front of a group of town officials, and then dismounted to stand “under arms” while Captain Carroll thanked the ladies of the town committee for food and clothing contributed to his outfit. On the lawns in front of the courthouse were wives, mothers, and sisters of several of the soldiers, many of them crying softly.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("When all the speeches were finished, the troops mounted, the first sergeant shouted out the order to march, and the unit wheeled about and rode out of Van Buren, heading for DeRosey Carroll’s cavalry camp at Camp Walker. An observer at the ceremony in Van Buren later wrote that he was “assured that soldiers who leave for the battlefield with such blessings as the cavalry company received on Saturday, will make the bloodiest ranks in the conflict with the enemy.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt33ch1",
      "id": "rnt33ch1"
    }
  }, [_vm._v("33")])])]), _vm._v(" And perhaps the memory of this ceremony did encourage the men to fight bravely in the bitter campaigns that followed.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("At Camp Walker, Carroll’s outfit became Company A of the First Arkansas Cavalry Regiment. The other seven companies of the regiment came mainly from Franklin, Johnson, and contiguous counties. On May 29 the troops held regimental elections, and chose DeRosey Carroll their colonel."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt34ch1",
      "id": "rnt34ch1"
    }
  }, [_vm._v("34")])])]), _vm._v(" Late in June, N. Bart Pearce, brigadier general of Arkansas in command of the western frontier, gathered Carroll’s regiment, Gratiot’s and Dockery’s infantry regiments, and Reid’s and Woodruff’s batteries and marched to Fort Smith. There he placed his entire command of state troops at the disposal of General McCulloch."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt35ch1",
      "id": "rnt35ch1"
    }
  }, [_vm._v("35")])])]), _vm._v(" At length, on July 15, the Arkansas Military Board ordered the transfer of these state volunteers to the Confederate service."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt36ch1",
      "id": "rnt36ch1"
    }
  }, [_vm._v("36")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("While companies were recruited for DeRosey Carroll’s regiment, Colonel Thomas J. Churchill (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 1")]), _vm._v("), having received a Confederate commission, began in May to raise a cavalry regiment in counties around Fort Smith. He had some difficulty in obtaining volunteers at first because of the indefinite period of enlistment—for the war."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt37ch1",
      "id": "rnt37ch1"
    }
  }, [_vm._v("37")])])]), _vm._v(" On May 22, however, the War Department authorized him to receive troops for twelve-months service,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt38ch1",
      "id": "rnt38ch1"
    }
  }, [_vm._v("38")])])]), _vm._v(" and by June 17 he had a full regiment (768 men), which he named the First Arkansas Mounted Rifles. After holding elections, in which Churchill became colonel, the regiment joined McCulloch’s command at Fort Smith."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt39ch1",
      "id": "rnt39ch1"
    }
  }, [_vm._v("39")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("In July Captain James McIntosh organized and equipped the Second Arkansas Mounted Rifles, made up of ten companies (662 men) from various counties in northwestern Arkansas. An election was held, which resulted in McIntosh being made colonel, and then the regiment was sworn into Confederate service for the war."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt40ch1",
      "id": "rnt40ch1"
    }
  }, [_vm._v("40")])])]), _vm._v(" Late in July the outfit rode into Fort Smith, bringing McCulloch’s effective strength to about 3,000 men, some 2,000 of them horsemen.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("While officers were raising troopers in Arkansas for McCulloch’s army, Colonel Elkanah Greer and Captain J. A. Harris of Marshall, Texas, issued calls for volunteers from Dallas and surrounding counties and named Dallas as their rendezvous point."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt41ch1",
      "id": "rnt41ch1"
    }
  }, [_vm._v("41")])])]), _vm._v(" The request for troops was answered promptly by many home guard companies.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Captain Frank M. Taylor of the “Lone Star Defenders,” a home guard cavalry company at Rusk, Texas, received Greer’s call for men on June 9. The next day, Taylor assembled his men in front of the Thompson Hotel and made preparations for the ride to Dallas. The activities of the troops aroused the inhabitants of the town, and they gathered around the hotel to watch the departing ceremonies. “Men, women, and children,” recalled one trooper, “were on the streets, in tears, to bid us farewell. Even rough, hard-faced men whose appearance would leave one to believe they hadn’t shed a tear since boyhood, boo-hoo’d and were unable to speak the word ‘good-by.’” The day of departure, decided the soldier, “was the saddest of the war for many of us.” After a “formal and very tender” farewell address from dignified old General J. L. Hogg, father of James S. Hogg, later governor of Texas, the men sorrowfully mounted their ponies and, riding out of town, sang in unison")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('div', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The Lone Star Defenders, a gallant little band,")])]), _vm._v(" "), _c('div', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("On the tenth of June left their native land. …"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt42ch1",
      "id": "rnt42ch1"
    }
  }, [_vm._v("42")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("Dallas was the scene of much activity as companies of whooping volunteers rode in to join Greer’s regiment. Soon ten companies, including Taylor’s unit, had reported to Greer, and on the afternoon of June 13 were organized into the Third Texas Cavalry Regiment."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt43ch1",
      "id": "rnt43ch1"
    }
  }, [_vm._v("43")])])]), _vm._v(" The process of swearing the men into Confederate service was simple. “We were subjected to no physical examination or other foolishness,” recalled Lieutenant Samuel Barron, “but every fellow was taken for better or for worse, and no questions were asked, except the formal, ‘Do you solemnly swear,’ etc.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt44ch1",
      "id": "rnt44ch1"
    }
  }, [_vm._v("44")])])]), _vm._v(" The men then held elections, choosing Greer their colonel, Walter P. Lane, lieutenant colonel, and G. W. Chilton, major."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt45ch1",
      "id": "rnt45ch1"
    }
  }, [_vm._v("45")])])]), _vm._v(" On July 8 the men of the Third Texas, having been delayed for three weeks until arms were sent from San Antonio, broke camp and rode out of town two abreast by companies. Each company proudly flew its own flag, which contained its alphabetical designation and some name which connoted bravery, fierceness, and patriotism to Texas. For example, Company A was the “Texas Hunters,” Company C, the “Lone Star Defenders,” and Company G, the “Dead Shot Rangers.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt46ch1",
      "id": "rnt46ch1"
    }
  }, [_vm._v("46")])])]), _vm._v(" With ten silk flags fluttering in the wind above their heads, the troops rode through towns and villages on the road to Fort Smith in great “military style and military pomp.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt47ch1",
      "id": "rnt47ch1"
    }
  }, [_vm._v("47")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("At Fort Smith the regiment found that McCulloch had marched into Missouri to reinforce Sterling Price’s state army, which was fighting desperately to hold southwestern Missouri for the Confederacy. Following McCulloch, the Third Texas, on August 4, reached the Confederate encampment on Crane Creek, some twenty miles southwest of Springfield."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt48ch1",
      "id": "rnt48ch1"
    }
  }, [_vm._v("48")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Two days later General Price turned over his Missouri State Guards to McCulloch, bringing the total force under his command to 6,000 cavalry, partly armed with shotguns, rifles, and muskets, 5,300 infantry, and fifteen pieces of artillery."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt49ch1",
      "id": "rnt49ch1"
    }
  }, [_vm._v("49")])])]), _vm._v(" Opposing McCulloch in Missouri was a well-drilled, fully armed Federal army, numbering about 8,000 men, under Major General Nathaniel Lyon, then encamped at Springfield."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt50ch1",
      "id": "rnt50ch1"
    }
  }, [_vm._v("50")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("McCulloch, deciding to engage the Federals without delay, ordered a general advance on the night of August 9. At about 1:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" the Confederates, having marched over muddy roads in blowing rain, drew up in line by regiments along Wilson’s Creek, a few miles below Springfield. On the left were Price’s Missourians, with the brigades of Generals W. Y. Slack, John B. Clark, James H. McBride, M. M. Parsons, and James S. Rains, and William E. Woodruff’s Arkansas artillery. In the center were Hébert’s infantry and McIntosh’s regiment of cavalry, dismounted. Completing the line on the right flank were Churchill’s and Greer’s cavalry, dismounted."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt51ch1",
      "id": "rnt51ch1"
    }
  }, [_vm._v("51")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Meanwhile, Lyon had split his force into two columns, one under himself, the other under General Franz Sigel. Simultaneous with McCulloch’s advance, the two Federal columns marched to Wilson’s Creek, Lyon taking a position opposite Price, while Sigel slipped around McCulloch’s right flank and into his rear."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt52ch1",
      "id": "rnt52ch1"
    }
  }, [_vm._v("52")])])]), _vm._v(" At 5:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.,")]), _vm._v(" following a terrific artillery barrage, the Yankees took the offensive, with Lyon attacking Price and Sigel driving into Greer’s and Churchhill’s flanks. McCulloch, seeing his right wing buckling, moved McIntosh’s and Hébert’s regiments to cover the flank and rear of Greer’s cavalry. The fighting was hot in this quarter, each side trying to outmaneuver the other. Finally, in a furious charge, McCulloch’s yipping troops smashed Sigel’s column, forcing it to retreat back to Springfield. McCulloch then joined Price. The combined Confederate forces completely routed Lyon’s army, Lyon himself being killed in the fighting."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt53ch1",
      "id": "rnt53ch1"
    }
  }, [_vm._v("53")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The Confederate victory at Wilson’s Creek was short-lived. McCulloch, whose army was drastically short of arms and supplies, fell back to Arkansas, where he remained for the rest of 1861. Price’s haggard army, refusing to give up its home state, continued the war in southwestern Missouri until February, 1862, when exhausted and starving, it too withdrew to Arkansas.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent1"
  }, [_c('span', [_vm._v("Back in May, while enrolling officers recruited cavalry in Texas and Arkansas, McCulloch and Albert Pike, Commissioner of Indian Affairs for the Confederate government, took steps to enlist Indian cavalry in the Confederate Army.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("The powerful Cherokee Nation, whose chieftain John Ross envisioned an independent Indian confederation, had issued in May a proclamation stating their neutrality in the current war."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt54ch1",
      "id": "rnt54ch1"
    }
  }, [_vm._v("54")])])]), _vm._v(" This action angered Pike and McCulloch, and they set to work to force the Cherokees over to the side of the Confederacy. From July 10 to August 4, 1861, Pike negotiated treaties of alliance with the Creeks, Seminoles, Comanches, Chickasaws and Choctaws, the Wichitas, the Osages in the Cherokee Nation, the Senecas, the Quapaws, and the Shawnees."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt55ch1",
      "id": "rnt55ch1"
    }
  }, [_vm._v("55")])])]), _vm._v(" McCulloch proceeded to surround the Cherokees with Confederate troops, white and Indian, so as to “force the conviction on the Cherokees that they have but one course to pursue—that is, to join the Confederacy.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt56ch1",
      "id": "rnt56ch1"
    }
  }, [_vm._v("56")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The general had recruited the first Indian cavalry unit for this purpose from the Choctaws and Chickasaws. On June 10 a Choctaw National Council convening at Doaksville authorized Chief Hudson to gather seven companies of mounted men, to be designated the First Regiment, Choctaw and Chickasaw Mounted Rifles."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt57ch1",
      "id": "rnt57ch1"
    }
  }, [_vm._v("57")])])]), _vm._v(" The regiment, formed by the end of July under D. H. Cooper and numbering 1,085 men,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt58ch1",
      "id": "rnt58ch1"
    }
  }, [_vm._v("58")])])]), _vm._v(" was assigned to Ben McCulloch, who promptly stationed it on the border of Cherokee country.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("In August, at the time the Cherokees were assembled at a meeting in Tahlequah, McCulloch authorized squat, fiery, old Stand Watie (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 2")]), _vm._v("), a pro-Southern Cherokee recently commissioned a colonel in the Confederate Army, to raise a body of cavalry to protect the northern border of the Cherokee Nation “from the inroads of the jayhawkers of Kansas.” Watie had strict instructions not to interfere with Cherokee neutrality,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt59ch1",
      "id": "rnt59ch1"
    }
  }, [_vm._v("59")])])]), _vm._v(" but he was vehemently opposed to Ross’ policy and succeeded in inducing adventurous young Cherokees to sneak across into Arkansas and join his unit."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt60ch1",
      "id": "rnt60ch1"
    }
  }, [_vm._v("60")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Arkansas citizens had earlier asked Watie to urge his nation to “join us in our efforts for mutual defense.” On May 18 A. M. Wilson and J. W. Washbourne of Fayetteville had informed him that a number of “good guns” had been granted to the state for distribution to the Cherokees “in the defense of their and our frontier.” In a sly P.S. the two men noted that the “notorious” “abolitionist,” “robber,” “murderer,” and “rascal,” Jim Lane, protecting the Federal agent for the Cherokees with a body of Union troops, was ignorant of Watie’s pro-Confederate sentiments. Therefore, Watie should organize his Cherokees “silently,” so they could the “more easily ambush and surprise him [Lane] & take "), _c('i', [_vm._v("booty")]), _vm._v(".”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt61ch1",
      "id": "rnt61ch1"
    }
  }, [_vm._v("61")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("By the end of August, Watie had gathered together a battalion of 300 Indians. Taking up a position in the Cherokee neutral lands in Kansas, he awaited further instructions from McCulloch, who by that time was back at Fort Smith after his short campaign in Missouri."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt62ch1",
      "id": "rnt62ch1"
    }
  }, [_vm._v("62")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("With many of his Indians already in the Confederate Army and contiguous tribes allied with the South, John Ross became convinced that his best course was to side with the Confederacy, and a treaty to this effect was negotiated in October."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt63ch1",
      "id": "rnt63ch1"
    }
  }, [_vm._v("63")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("Afterwards, the Cherokee Nation not only contributed several additional companies to Watie’s battalion, raising it to a full regiment of 800 men (First Cherokee Mounted Rifles), but also organized the Second Cherokee Mounted Rifles, 1,000 strong, under the leadership of John Drew."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt64ch1",
      "id": "rnt64ch1"
    }
  }, [_vm._v("64")])])]), _vm._v(" By this time four additional Indian outfits had been raised in the other Nations. These were the First Creek Cavalry Regiment (900 men), Colonel D. N. McIntosh; the First Creek Cavalry Battalion (400 men), Lieutenant Colonel Chilly McIntosh; Creek Cavalry Company (75 men), Captain J. McSmith; the First Seminole Battalion, Lieutenant Colonel John Jumper; and the Second Regiment, Choctaw and Chickasaw Mounted Rifles, Colonel Tandy Walker. The War Department placed all these outfits under Albert Pike, recently appointed brigadier general to command the Indian troops raised under his treaties. Colonel D. H. Cooper was the field commander of this Indian brigade, which numbered 5,500 effectives."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt65ch1",
      "id": "rnt65ch1"
    }
  }, [_vm._v("65")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent1"
  }, [_c('span', [_vm._v("In July the Confederate War Department agreed to a sweeping cavalry campaign across New Mexico and Arizona, which had been proposed by General Henry Hopkins Sibley (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 3")]), _vm._v("), a debonair aristocrat who was conspicuous for wearing long, thin sideburns which drooped down below a flashy handlebar mustache."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt66ch1",
      "id": "rnt66ch1"
    }
  }, [_vm._v("66")])])]), _vm._v(" Sibley arrived in Texas in the middle of August with orders to raise twenty companies of cavalry and a battery of howitzers with which to invade New Mexico and Arizona."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt67ch1",
      "id": "rnt67ch1"
    }
  }, [_vm._v("67")])])]), _vm._v(" Having reported to General P. O. Hébert, who had replaced General Van Dorn as commander of Texas,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt68ch1",
      "id": "rnt68ch1"
    }
  }, [_vm._v("68")])])]), _vm._v(" Sibley established his headquarters at San Antonio. There he hand-picked several enrolling captains and sent them into the surrounding counties to raise companies. Volunteers for these units were to furnish their own horses, rifles, and revolvers."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt69ch1",
      "id": "rnt69ch1"
    }
  }, [_vm._v("69")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("Sibley’s enrolling officer for the Hempstead-Bellville area, Captain Jerome B. McCown, began recruiting in September. First he placed notices in the Bellville "), _c('i', [_vm._v("Countryman")]), _vm._v(" stating that he was receiving volunteers for a cavalry company. Then he made camp on Clear Creek, just below Hempstead, where he began entering in his register the names of those enlisting. The "), _c('i', [_vm._v("Countryman")]), _vm._v(" assured potential volunteers that McCown “is a whole-souled fellow, and will divide his bottom dollar with a soldier.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt70ch1",
      "id": "rnt70ch1"
    }
  }, [_vm._v("70")])])]), _vm._v(" By September 11 the company was full. Late that afternoon the “Jackson Cavalry” lined up by squads in front of the courthouse in Bellville, listened to long addresses from leading citizens of the community, and then set out for San Antonio to join Sibley’s brigade."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt71ch1",
      "id": "rnt71ch1"
    }
  }, [_vm._v("71")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The streets of San Antonio were filled with the clamor of marching soldiers and the clatter of horse-drawn artillery as batteries and other cavalry outfits arrived and made ready for the New Mexico adventure. Three fully mounted regiments were organized in San Antonio and were known as “The Army of New Mexico.” These regiments were the Fourth Texas Volunteer Cavalry, Colonel James Reily; the Fifth Texas Volunteer Cavalry, Colonel Tom Green; and the Seventh Texas Volunteer Cavalry, Colonel William Steele. To these would be added at El Paso Lieutenant Colonel John R. Baylor’s Second Texas Mounted Rifles, bringing Sibley’s total force to about 3,700 men. Several factors weighed powerfully against the success of this expedition—the strength of Federal forces in New Mexico, a shortage of ammunition and supplies, and the lack of specific information on road conditions. On February 21, 1862, the expeditionary force fought a Yankee army at Valverde, on the Rio Grande, a few miles above Fort Craig, New Mexico. Confederate columns then pushed northward and on March 26 fought a second Yankee force at Glorieta Pass, at the southern extremity of the Sangre de Cristo Range some twenty miles southeast of Santa Fe. Afterwards, Sibley’s exhausted and starving horsemen began a desperate retreat down the Rio Grande, reaching Texas in the late spring of 1862, their ranks thinned by some 1,700 casualties on the campaign. Thus ended the Confederate dream of gaining all the country from the Rio Grande to the Pacific Ocean."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt72ch1",
      "id": "rnt72ch1"
    }
  }, [_vm._v("72")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("Several of the crack cavalry outfits raised in the Trans-Mississippi during 1861 were immediately transferred to the larger seats of war in Kentucky and Virginia."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt73ch1",
      "id": "rnt73ch1"
    }
  }, [_vm._v("73")])])]), _vm._v(" One of these was Colonel William F. Slemons’ Second Arkansas Cavalry Regiment, raised in July and transferred to Columbus, Kentucky, probably in August."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt74ch1",
      "id": "rnt74ch1"
    }
  }, [_vm._v("74")])])]), _vm._v(" Two others were Terry’s Texas Rangers, which would become one of the most celebrated of Texas cavalry regiments, and Scott’s First Louisiana Cavalry Regiment, the first mounted outfit raised for the Confederate Army in that state.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Benjamin F. Terry, a wealthy sugar planter from Fort Bend County, Texas, and Thomas S. Lubbock of Houston had travelled to Virginia to volunteer in the Confederate Army shortly after Fort Sumter. The two men later served on the staff of General Pierre Gustave Toutant Beauregard at the battle of First Manassas (Bull Run), after which they secured permission from the War Department to recruit a regiment of cavalry in Texas for service in Virginia."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt75ch1",
      "id": "rnt75ch1"
    }
  }, [_vm._v("75")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v("Returning to Texas by rail and horseback, Terry and Lubbock established the muster center for the regiment at Houston. Then they sent ten recruiting captains into the southern part of the state. Each officer was instructed to raise a company of 100 horsemen, each volunteer to furnish his own weapon (preferably a double-barreled shotgun), a pair of six-shooters, bridle, saddle, spurs, lariat, and mount."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt76ch1",
      "id": "rnt76ch1"
    }
  }, [_vm._v("76")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Terry’s enrolling officer for Bastrop and contiguous counties was Stephen C. Ferrell. Arriving there sometime in August, he issued an urgent call for troops and was surprised at the quick and enthusiastic response. Everyone was eager to support the Confederate cause. “War, war, war,” wrote one correspondent, “is the daily conversation of every lady and gentleman that I meet.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt77ch1",
      "id": "rnt77ch1"
    }
  }, [_vm._v("77")])])]), _vm._v(" Men of draft age were equally exuberant. “I was fearful,” remarked one volunteer, “that the war would be over before I saw a live Yankee. So Charley McGhee and I went fifty miles from home to join” Ferrell’s company being organized between Bastrop and LaGrange."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt78ch1",
      "id": "rnt78ch1"
    }
  }, [_vm._v("78")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Within a week, Ferrell’s muster roll was full. He posted throughout Bastrop, Hays, Travis, and Burleson counties notices designating Bastrop as the organization center for the company. On the eve of the muster day, bodies of green, rowdy volunteers converged on Bastrop. They drank and celebrated well into the night. The next morning the people of the town gathered at the square to see the men conduct elections and to witness the departing ceremonies. Mingling with the troops were women, elderly men, and children who “with tears in their eyes” clasped the soldiers’ hands and blessed them for their heroism and patriotism. When this “painful ordeal” was over, the company rode out of Bastrop “on what we believed was a few month’s venture.” The next day they entered Terry’s makeshift camp at an old warehouse on the outskirts of Houston.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v("Within a few days all ten companies had arrived in Houston. Captain John A. Wharton (Portrait on "), _c('span', {
    attrs: {
      "href": "#/plates#pla7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 7")]), _vm._v(") brought a company from Brazoria and Matagorda counties; Captain James G. Walker one from Harris and Montgomery counties; and Captain Louis N. Strobel a company from Fayette County. Three companies were from the area around Gonzales, the other four mainly from MeLennan, Bexar, Goliad, and Fort Bend counties."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt79ch1",
      "id": "rnt79ch1"
    }
  }, [_vm._v("79")])])]), _vm._v(" On September 9, less than thirty days after Terry and Lubbock had returned to Texas, the regiment, numbering 1,170 men, was mustered into Confederate service."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt80ch1",
      "id": "rnt80ch1"
    }
  }, [_vm._v("80")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("For the mustering-in ceremony, all ten companies lined up on three sides of a large, open square. Lieutenant J. Sparks, who had resigned from the United States Army and was on his way to Richmond to volunteer in the Confederate Army, administered the oath of allegiance. Sparks stood in the center of the square, and in a powerful voice which drowned out the dull commotion of whispering and shuffling, he asked, “Do you men wish to be sworn into service for twelve months or for three years or for during the war?” A moment of silence followed. Then the men shouted enthusiastically “For the War!” “For the War!” After the ceremony, the troops marched back to camp where they prepared for a long, grueling march to Virginia."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt81ch1",
      "id": "rnt81ch1"
    }
  }, [_vm._v("81")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The personnel of the Rangers “was of the very highest.” Sons of prominent families, college graduates, merchants, bankers, lawyers, cowboys, expert with lariats and six-shooters, and farmers all served as privates. They were, according to one Ranger, “all young, in their teens and early twenties.” No one paid much attention to rank. “The supreme desire,” said L. B. Giles of Company D, “was to get into the war in a crack cavalry regiment.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt82ch1",
      "id": "rnt82ch1"
    }
  }, [_vm._v("82")])])]), _vm._v(" And the Rangers were indeed a crack regiment, as they proved later in battle.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v("While the Rangers waited for the order to move, Strobel’s company “kept the town in a continued bustle with their daring feats of horsemanship.” To “show what they could do,” the men formed in squads and rode at a maddening gallop down the streets, jumping off and on their mounts and picking pieces of cloth and sticks off the ground. To the exasperation of peace-loving civilians, some of the men would break wild horses in the middle of town. With all this showmanship, a newspaperman decided the Rangers were about the toughest outfit in the Confederate Army. Hardened from encounters with “the stealthy panther and more savage Mexican hog, in our forests,” they would be the “pride of Texas” and would make “the enemy beware” when they “get on their track.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt83ch1",
      "id": "rnt83ch1"
    }
  }, [_vm._v("83")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("On September 10, 1861, the Rangers rode to Beaumont, left their horses, and then marched on foot to New Orleans, whence they sailed up the Mississippi to Bowling Green, Kentucky, to join General Albert Sidney Johnston’s command. The election of officers, held after the unit reached Bowling Green, made Terry colonel."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt84ch1",
      "id": "rnt84ch1"
    }
  }, [_vm._v("84")])])]), _vm._v(" The Rangers served the rest of the war east of the Mississippi, leaving two thirds of their numbers on some of the bloodiest battlefields of the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Like Terry’s regiment, Colonel John S. Scott’s Louisiana cavalry outfit was raised for the specific purpose of serving in either Virginia or Kentucky. As a reward for valuable services on the Peninsula and a brilliant understanding of cavalry command, President Davis had, by an order of July 15, 1861, authorized Scott to recruit a regiment for himself. Arriving in New Orleans on July 21, Scott promptly selected 10 enrolling officers to go into country parishes to raise companies of cavalry."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt85ch1",
      "id": "rnt85ch1"
    }
  }, [_vm._v("85")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("One of the enrolling officers was a Lieutenant Hasley of New Orleans. Sometime in August, Hasley established his enrolling center at the St. Charles Hotel, but he recruited most of the company from parishes north of the city and called it the “Pointe Coupee Cavalry.” On September 27 a notice in the New Orleans "), _c('i', [_vm._v("Daily Crescent")]), _vm._v(" asked for fifteen men from New Orleans to fill out the company. The "), _c('i', [_vm._v("Crescent")]), _vm._v(" described this as a “rare chance.” Only the “best class of men” was being received. The men of New Orleans responded rapidly, and within a few days Hasley’s company was full. It organized at New Orleans and then rode for Scott’s camp, pitched near Baton Rouge."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt86ch1",
      "id": "rnt86ch1"
    }
  }, [_vm._v("86")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v("The First Louisiana Cavalry, composed of 750 men in ten companies, was mustered into Confederate service in November, 1861. In the elections for regimental officers, held shortly thereafter, Scott was chosen colonel and J. O. Nixon, editor and proprietor of the New Orleans "), _c('i', [_vm._v("Daily Crescent")]), _vm._v(", lieutenant colonel. The regiment then went into camp inside Baton Rouge for several weeks of drill and training in the principles of cavalry warfare."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt87ch1",
      "id": "rnt87ch1"
    }
  }, [_vm._v("87")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Scott’s regiment had been raised without expense to the government. The cost, said to have been $50,000, was met by subscriptions from private parties in the country parishes whence over 90 per cent of the volunteers had come."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt88ch1",
      "id": "rnt88ch1"
    }
  }, [_vm._v("88")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Before the First left Baton Rouge, a section of light artillery, consisting of 25 men, two mountain howitzers, and one rifled four-pounder, was assigned to it from Watson’s Battalion. Towards the last of November, the regiment sailed on river boats up the Mississippi to Bowling Green, Kentucky. The outfit never returned to the Trans-Mississippi theater of war.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("By the end of December, 1861, the Trans-Mississippi had raised, mounted, and equipped a large number of cavalry units for Confederate service. Texas had placed sixteen regiments, three battalions, and three independent companies in the field (17,338 men);"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt89ch1",
      "id": "rnt89ch1"
    }
  }, [_vm._v("89")])])]), _vm._v(" Arkansas, five regiments and five battalions (5,145 men); the Indian Territory, five regiments, two battalions, and one independent company (5,460 men); and Louisiana, one regiment (750 men). See "), _c('a', {
    attrs: {
      "href": "#/#rtab1"
    }
  }, [_vm._v("Table I")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v("With the exception of Louisiana this was a good showing in comparison to the number of infantry raised in 1861. In Texas only seven regiments and four battalions of infantry had been raised by December—about 7,100 men."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt90ch1",
      "id": "rnt90ch1"
    }
  }, [_vm._v("90")])])]), _vm._v(" This gave the cavalry from the state a numerical superiority of approximately 2.4 to 1. Arkansas had produced eight regiments and one battalion of infantry, 5,887 men"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt91ch1",
      "id": "rnt91ch1"
    }
  }, [_vm._v("91")])])]), _vm._v("—a numerical ratio of 1.2 to 1 in favor of the infantry. In Louisiana the infantry was far out in front with twenty regiments and five battalions, 22,733 men,"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt92ch1",
      "id": "rnt92ch1"
    }
  }, [_vm._v("92")])])]), _vm._v(" in contrast to the single cavalry regiment of 750 men—an infantry supremacy of slightly more than 30 to 1. No infantry units were raised in the Indian Territory. In total figures the cavalry from the Trans-Mississippi numbered about 28,693, the infantry some 35,720—a slim advantage of 1.25 to 1 for the infantry.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The definite preference for cavalry service among the Texans provided a constant source of exasperation for Governor Clark. Back in April he had received from the War Department a request for 8,000 infantrymen from Texas to fight in Confederate armies east of the Mississippi. To meet the request, Clark obtained commissions for prominent citizens and detailed them into counties throughout the state. The officers soon found that Texans, well-known for their peerless horsemanship, would have little to do with the unromantic infantry service. Every man wanted to join the cavalry and make a lasting impression on young ladies and relatives by riding off to war on a powerful horse as an improvised band played “The Girl I Left Behind Me” or “The Yellow Rose of Texas.” The preference soon became a “passion for mounted service” as men flatly refused to join any service that required walking. In desperation, the governor directed that camps of instruction be set up throughout the state to instruct raw recruits in the art of infantry service. These camps attempted to show the men that the infantry actually was every bit as glorious as the cavalry. But most of the Texans were not fooled by Clark’s efforts, or by similar efforts on the part of succeeding governors, Francis R. Lubbock and Pendleton Murrah. Until conscription laws forced them into the infantry, Texans rushed to enlist as gallant cavalrymen."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#nt93ch1",
      "id": "rnt93ch1"
    }
  }, [_vm._v("93")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v("The results of recruiting volunteers in 1861 were for the cavalry excellent numerically, but the outfits retained in the Trans-Mississippi were hardly an effective fighting force. In the absence of an over-all regional command during 1861, there was no Trans-Mississippi army as such, and consequently no real organization of the cavalry. Mounted units were scattered from the Mississippi to New Mexico, and from the Rio Grande to Lexington, Missouri.")])]), _vm._v(" "), _c('div', {
    staticClass: "thead"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/tables#tab1",
      "id": "rtab1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("TABLE I")])])])]), _vm._v(" "), _c('div', {
    staticClass: "thead1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/tables#tab1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Confederate Cavalry Units Raised in the Trans-Mississippi during 1861")])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-size": "90%"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("TEXAS"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#rnt1",
      "id": "nt1"
    }
  }, [_vm._v("a")])])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Unit")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Commander")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Troops")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Station")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg. (Mted. Rifles)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("H. E. McCulloch")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,000")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Texas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg. (Arizona Brigade)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("W. P. Hardeman")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   800 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("New Mexico")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("2nd Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. S. Ford")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,200")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Texas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("2nd Reg. (Mted. Rifles)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. R. Baylor")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   700")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("New Mexico")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("3rd Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Joseph Phillips")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   796")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Texas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("3rd Reg. (South Kansas-Texas Reg.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Elkanah Greer")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,200")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("4th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("James Reily")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,000")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("New Mexico")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("5th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Tom Green")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,000")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("New Mexico")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("6th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("B. W. Stone")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,150")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("7th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("William Steele")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,000")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("New Mexico")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("9th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("W. B. Sims")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,050")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("10th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("M. F. Locke")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   900 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Texas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("11th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("W. C. Young")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   855")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("12th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("W. H. Parsons")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   940 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("18th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("N. H. Darnell")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   900 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Texas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Terry’s Reg. (also referred to as 8th Tex.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("B. F. Terry")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("1,170")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Kentucky")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("De Bray’s Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("X. B. De Bray")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   700")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Texas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Whitfield’s Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. W. Whitfield")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   339")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("6th Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("R. S. Gould")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   400 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Burnett’s Company")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. R. Burnett")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     84")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Hill’s Company")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Hill")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     77")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Turner’s Company")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Turner")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     77")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('span', {
    staticClass: "table-lefta"
  }, [_vm._v("17,338")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("LOUISIANA")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Unit")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', [_vm._v("Commander")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Troops")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Station")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. S. Scott")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("750")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Kentucky")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('span', {
    staticClass: "table-lefta"
  }, [_vm._v("750")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v("ARKANSAS"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#rnt2",
      "id": "nt2"
    }
  }, [_vm._v("b")])])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Unit")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Commander")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Troops")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Station")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#rnt3",
      "id": "nt3"
    }
  }, [_vm._v("c")])])])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("C. A. Carroll")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   700 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg. (Mted. Rifles)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("T. J. Churchill")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   768")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("2nd Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("W. F. Slemons")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   800 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Kentucky")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("2nd Reg. (Mted. Rifles)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("James McIntosh")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   662")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("5th Reg.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("R. C. Newton")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   700")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Borland’s Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Solon Borland")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   568")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Brooks’ Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("W. H. Brooks")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   316")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Scott’s Squadron")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. R. H. Scott")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   181")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Wheat’s Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("P. H. Wheat")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   200 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("Witherspoon’s Bn.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("B. N. Witherspoon")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("   250 (est.)")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Arkansas")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('span', {
    staticClass: "table-lefta"
  }, [_vm._v("5,145")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v("INDIAN TERRITORY"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#rnt4",
      "id": "nt4"
    }
  }, [_vm._v("d")])])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Unit")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Commander")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Troops")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('i', [_vm._v("Station")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg., Choct. & Chick.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("D. H. Cooper")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("  1,085")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("2nd Reg., Choct. & Chick.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Tandy Walker")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     800")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg., Cherokee Mted. Rifles")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Stand Watie")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("  1,000")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("2nd Reg., Cherokee Mted. Rifles")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("John Drew")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     800")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Reg., Creek Cav.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("D. N. McIntosh")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     900")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Bn., Creek Cav.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Chilly McIntosh")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     400")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("McSmith’s Creek Company")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("J. McSmith")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("       75")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left1"
  }, [_vm._v("1st Bn., Seminole Cav.")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("John Jumper")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("     400")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_vm._v("Indian Territory")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('span', {
    staticClass: "table-lefta"
  }, [_vm._v("  5,460")])]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "table-left",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total Number of Cavalry Raised in 1861")]), _vm._v(" "), _c('td', {
    staticClass: "table-left"
  }, [_c('span', {
    staticClass: "table-lefta"
  }, [_vm._v("28,693")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    staticStyle: {
      "margin-top": "0.5em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#nt1",
      "id": "rnt1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("a")])])])]), _vm._v(" Texas data compiled from Abstracts of Monthly Troop Returns, August 31, and October, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 690, 730; Abstract of Monthly Troop Returns, December 31, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. VIII, 718–719; Statement of Organized Confederate Units, September, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. IV, vol. I, 630; Wooten, "), _c('i', [_vm._v("Comprehensive History of Texas")]), _vm._v(", II, 572–630; Dallas (Texas) "), _c('i', [_vm._v("Herald")]), _vm._v(", July 31, October 30, November 6, 1861; Roberts, “Texas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", XI, 45–58; Rose, "), _c('i', [_vm._v("Gen. Ben McCulloch")]), _vm._v(", pp. 129–134; Rose, "), _c('i', [_vm._v("Ross’ Texas Brigade")]), _vm._v(", pp. 132–135; Harrell, “Arkansas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", X, 70; U.S. War Department, "), _c('i', [_vm._v("List of Field Officers, Regiments and Battalions in the Confederate Army, 1861–1865")]), _vm._v(", pp. 71–78; and other sources cited in the text. For a list of these outfits see Fitzhugh, "), _c('i', [_vm._v("Texas Batteries, Battalions, Regiments, Commanders and Field Officers Confederate States Army")]), _vm._v(", pp. 4–5, 11–17.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#nt2",
      "id": "rnt2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("b")])])])]), _vm._v(" Arkansas data compiled from Abstracts of Monthly Troop Returns, August 31, and October, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 690, 730; Abstract of Monthly Troop Returns, December 13, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. IV, vol. I, 788–789; Abstract of Monthly Troop Returns, December 31, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. III, 718–719; Statement of Organized Confederate Units, September, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. IV, vol. I, 627; Harrell, “Arkansas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", X, 70; Hempstead, "), _c('i', [_vm._v("Pictorial History of Arkansas")]), _vm._v(", pp. 363–427; Colonel V. Y. Cook, “List of General and Field Officers, Arkansas Troops, C.S.A., and State Troops,” "), _c('i', [_vm._v("Publications of the Arkansas Historical Association")]), _vm._v(", I (1906), 411–421; and other sources cited in the text.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#nt3",
      "id": "rnt3"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("c")])])])]), _vm._v(" DeRosey Carroll’s First Arkansas Cavalry broke up in the summer of 1861. Company A of this regiment under Charles A. Carroll formed the basis of a new regiment, composed of many of DeRosey Carroll’s old companies and a few new ones. Charles A. Carroll’s outfit took the designation of the First Arkansas Cavalry.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#nt4",
      "id": "rnt4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("d")])])])]), _vm._v(" Albert Pike to J. P. Benjamin, November 27, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. VIII, 697; Abel, "), _c('i', [_vm._v("American Indian as a Slaveholder and Secessionist")]), _vm._v(", pp. 240–253; and Harrell, “Arkansas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", X, 70, 98, 198.")])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    staticStyle: {
      "margin-top": "5.0em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt1ch1",
      "id": "nt1ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("1")])])])]), _vm._v(" J. K. P. Blackburn, “Reminiscences of the Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII (July, 1918), 38.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt2ch1",
      "id": "nt2ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("2")])])])]), _vm._v(" Quotation from Bellville (Texas) "), _c('i', [_vm._v("Countryman")]), _vm._v(", September 18, 1861. For McCulloch’s activities before the war see Victor M. Rose, "), _c('i', [_vm._v("The Life and Services of Gen. Ben McCulloch")]), _vm._v(", pp. 40–121; and Jack Winton Gunn, “Life of Ben McCulloch,” pp. 1–80.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt3ch1",
      "id": "nt3ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("3")])])])]), _vm._v(" Van Buren (Arkansas) "), _c('i', [_vm._v("Press")]), _vm._v(", June 5, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt4ch1",
      "id": "nt4ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("4")])])])]), _vm._v(" Caroline B. Darrow, “Recollections of the Twigs Surrender,” in "), _c('i', [_vm._v("Battles and Leaders of the Civil War")]), _vm._v(", I, 34–35; Blackburn, “Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII, 38–39.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt5ch1",
      "id": "nt5ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("5")])])])]), _vm._v(" D. E. Twiggs to C. L. Thomas, February 19, 1861, United States War Department, "), _c('i', [_vm._v("The War of the Rebellion: A Compilation of the Official Records of the Union and Confederate Armies")]), _vm._v(", ser. I, vol. I, 504. Hereafter cited "), _c('i', [_vm._v("Official Records")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt6ch1",
      "id": "nt6ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("6")])])])]), _vm._v(" Blackburn, “Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII, 39; Oran M. Roberts, “Texas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", XI, 25.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt7ch1",
      "id": "nt7ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("7")])])])]), _vm._v(" This committee was set up by the Texas Secession Convention to prepare the state for war. It raised a state army to fight the Federals and to ensure the safety of Texas citizens until the Confederate Army should become effective in Texas. Charles W. Ramsdell, “The Texas State Military Board, 1862–1865,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXVII, 253–260.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt8ch1",
      "id": "nt8ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("8")])])])]), _vm._v(" Edward Clark to Jefferson Davis, April 4, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. I, 621; Dudley G. Wooten, ed., "), _c('i', [_vm._v("A Comprehensive History of Texas")]), _vm._v(", II, 573–574. James B. Barry, "), _c('i', [_vm._v("A Texas Ranger and Frontiersman: The Days of Buck Barry in Texas, 1845–1906")]), _vm._v(", pp. 127–129.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt9ch1",
      "id": "nt9ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("9")])])])]), _vm._v(" John S. Ford, Memoirs, V, 997.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt10ch1",
      "id": "nt10ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("10")])])])]), _vm._v(" Ford to J. C. Robertson, February 22, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. LIII, 651–652; James Thompson to G. D. Bailey, February 22, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. 1, 537–538.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt11ch1",
      "id": "nt11ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("11")])])])]), _vm._v(" For the documents relating to the surrender of Federal forts on the Rio Grande see "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. LIII, 618–666. Terse accounts may be found in the Galveston (Texas) "), _c('i', [_vm._v("Civilian")]), _vm._v(", March 11, 1861, and the "), _c('i', [_vm._v("Texas Almanac, 1861")]), _vm._v(", pp. 17–18.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt12ch1",
      "id": "nt12ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("12")])])])]), _vm._v(" General Orders No. 8, May 24, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. I, 574–575; Wooten, "), _c('i', [_vm._v("Comprehensive History of Texas")]), _vm._v(", II, 520.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt13ch1",
      "id": "nt13ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("13")])])])]), _vm._v(" Ford, Memoirs, V, 1000; Ford to Robertson, February 25, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. LIII, 655; Thomas North, "), _c('i', [_vm._v("Five Years in Texas: or, What You Did Not Hear during the War from January 1861 to January 1866")]), _vm._v(", p. 104.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt14ch1",
      "id": "nt14ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("14")])])])]), _vm._v(" San Antonio (Texas) "), _c('i', [_vm._v("Herald")]), _vm._v(", March 2, 1861; Belton (Texas) "), _c('i', [_vm._v("Democrat")]), _vm._v(", March 8, 1861; Texas Governor, March 16—November 7, 1861 (Edward Clark), "), _c('i', [_vm._v("Governor’s Message: Executive Office, Austin, March 29, 1861")]), _vm._v(", p. 5.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt15ch1",
      "id": "nt15ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("15")])])])]), _vm._v(" This description of the raising of Crawford’s company, later the W. P. Lane Rangers, is based upon William W. Heartsill, "), _c('i', [_vm._v("Fourteen Hundred and Ninety-One Days in the Confederate Army: or Camp Life, Day by Day, of the W. P. Lane Rangers from April 19, 1861 to May 20, 1865")]), _vm._v(", pp. 2–5.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt16ch1",
      "id": "nt16ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("16")])])])]), _vm._v(" The common practice during the first part of the war was to allow the men to elect the corporals and commissioned officers up to the rank of colonel. Brigadier generals and higher officers were appointed by the War Department.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt17ch1",
      "id": "nt17ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("17")])])])]), _vm._v(" Heartsill, "), _c('i', [_vm._v("Fourteen Hundred and Ninety-One Days")]), _vm._v(", pp. 2–5, 9.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt18ch1",
      "id": "nt18ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("18")])])])]), _vm._v(" Clarksville (Texas) "), _c('i', [_vm._v("Standard")]), _vm._v(", May 11, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt19ch1",
      "id": "nt19ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("19")])])])]), _vm._v(" Heartsill, "), _c('i', [_vm._v("Fourteen Hundred and Ninety-One Days")]), _vm._v(", pp. 14, 15–49.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt20ch1",
      "id": "nt20ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("20")])])])]), _vm._v(" Special Orders No. 18, July 25, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. IV, 95.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt21ch1",
      "id": "nt21ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("21")])])])]), _vm._v(" Roberts, “Texas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", XI, 47; Francis W. Johnson, "), _c('i', [_vm._v("A History of Texas and Texans")]), _vm._v(", IV, 1688.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt22ch1",
      "id": "nt22ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("22")])])])]), _vm._v(" Wooten, "), _c('i', [_vm._v("Comprehensive History of Texas")]), _vm._v(", II, 630.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt23ch1",
      "id": "nt23ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("23")])])])]), _vm._v(" X. B. De Bray to L. P. Walker, August 28, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. IV, 98–100.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt24ch1",
      "id": "nt24ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("24")])])])]), _vm._v(" Texas Adjutant General, "), _c('i', [_vm._v("Report, November, 1861")]), _vm._v(", p. 1; Texas Governor, March 16—November 7, 1861 (Edward Clark), "), _c('i', [_vm._v("Governor’s Message to the Senators and Representatives of the Ninth Legislature of the State of Texas, November 1, 1861")]), _vm._v(", p. 1. Hereafter cited (Texas) "), _c('i', [_vm._v("Governor’s Message, November 1, 1861")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt25ch1",
      "id": "nt25ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("25")])])])]), _vm._v(" Confederate States War Department, "), _c('i', [_vm._v("Regulations for the Army of the Confederate States and for the Quartermaster’s and Pay Departments, 1861")]), _vm._v(", pp. 183–184.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt26ch1",
      "id": "nt26ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("26")])])])]), _vm._v(" S. Cooper to Ben McCulloch, May 13, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 575–576.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt27ch1",
      "id": "nt27ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("27")])])])]), _vm._v(" Rose, "), _c('i', [_vm._v("Gen. Ben McCulloch")]), _vm._v(", p. 132.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt28ch1",
      "id": "nt28ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("28")])])])]), _vm._v(" General Orders No. 24, August 4, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 102–103; Ben McCulloch to S. Cooper, August 12, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 104–107; John M. Harrell, “Arkansas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", X, 133–136.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt29ch1",
      "id": "nt29ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("29")])])])]), _vm._v(" The Van Buren (Arkansas) "), _c('i', [_vm._v("Press")]), _vm._v(", April 24, 1861, erroneously calls this man John A. Carroll. In the summer of 1861 DeRosey Carroll’s state regiment broke up, but many of the companies formed a Confederate regiment under the command of Charles A. Carroll, who had been captain of Company A of the old state outfit. Later, in September, 1862, Charles A. Carroll was promoted to colonel in charge of the Arkansas Cavalry Brigade.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt30ch1",
      "id": "nt30ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt31ch1",
      "id": "nt31ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., May 1, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt32ch1",
      "id": "nt32ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., May 8, 22, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt33ch1",
      "id": "nt33ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., May 22, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt34ch1",
      "id": "nt34ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., May 22, 29, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt35ch1",
      "id": "nt35ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("35")])])])]), _vm._v(" Ben McCulloch to L. P. Walker, June 14, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 595; H. M. Rector to Walker, June 21, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v(".; McCulloch to Walker, June 29, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 600; Rose, "), _c('i', [_vm._v("Gen. Ben McCulloch")]), _vm._v(", p. 134; and David Y. Thomas, "), _c('i', [_vm._v("Arkansas in War and Reconstruction 1861–1874")]), _vm._v(", p. 108.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt36ch1",
      "id": "nt36ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. Ill, 609–610. After Arkansas seceded in May, a board consisting of Governor H. M. Rector and two advisors was entrusted with full military powers. It immediately began to organize the Army of Arkansas. The existence of a state army meant a dual military organization in Arkansas, where the Confederate Army was already operating. After two months of competition among recruiters for state service and for Confederate service, with resultant confusion, wasted manpower, and complete chaos in some areas, the state, in hopes of securing unity of command in Arkansas, decided to transfer all state units to the Confederate Army, the troops themselves choosing by vote whether to accept the change or be mustered out of service. In pursuance of this order, Lieutenant Colonel Solon Borland’s Arkansas cavalry battalion (568 men) and Lieutenant Colonel Charles W. Phifer’s battalion (181 men) were transferred to the command of General William J. Hardee, who was stationed at Pitman’s Ferry in northeastern Arkansas. Since Carroll’s cavalry had been transferred, all mounted outfits operating in the state were now in the Confederate Army. H. M. Rector to L. P. Walker, September 30, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 710; N. B. Pearce to Walker, October 10, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 715–716; and Thomas, "), _c('i', [_vm._v("Arkansas in War and Reconstruction")]), _vm._v(", pp. 87, 92–93, 95–96.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt37ch1",
      "id": "nt37ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("37")])])])]), _vm._v(" Ben McCulloch to L. P. Walker, May 20, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 581.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt38ch1",
      "id": "nt38ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("38")])])])]), _vm._v(" Walker to McCulloch, May 20, 22, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 581, 583.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt39ch1",
      "id": "nt39ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("39")])])])]), _vm._v(" Fort Smith (Arkansas) "), _c('i', [_vm._v("Daily Times and Herald")]), _vm._v(", June 17, 1861; Robert H. Dacus, "), _c('i', [_vm._v("Reminiscences of Company “H” First Arkansas Mounted Rifles")]), _vm._v(", p. 1; Fay Hempstead, "), _c('i', [_vm._v("A Pictorial History of Arkansas from Earliest Times to the Year 1890")]), _vm._v(", pp. 373–375.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt40ch1",
      "id": "nt40ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("40")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., p. 369.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt41ch1",
      "id": "nt41ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("41")])])])]), _vm._v(" Victor M. Rose, "), _c('i', [_vm._v("Ross’ Texas Brigade")]), _vm._v(", p. 16.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt42ch1",
      "id": "nt42ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("42")])])])]), _vm._v(" Samuel B. Barron, "), _c('i', [_vm._v("The Lone Star Defenders: A Chronicle of the Third Texas Cavalry, Ross’ Brigade")]), _vm._v(", pp. 17–18.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt43ch1",
      "id": "nt43ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("43")])])])]), _vm._v(" Rose, "), _c('i', [_vm._v("Ross’ Texas Brigade")]), _vm._v(", p. 16; Dallas (Texas) "), _c('i', [_vm._v("Herald")]), _vm._v(", June 19, July 3, 1861. The outfit was occasionally called the South Kansas-Texas Regiment probably because at the time of organization there was a vague hope of making an expedition into Kansas. The regiment later became a part of Ross’ celebrated Texas Brigade which fought east of the Mississippi.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt44ch1",
      "id": "nt44ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("44")])])])]), _vm._v(" Barron, "), _c('i', [_vm._v("Lone Star Defenders")]), _vm._v(", p. 23.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt45ch1",
      "id": "nt45ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("45")])])])]), _vm._v(" Rose, "), _c('i', [_vm._v("Ross’ Texas Brigade")]), _vm._v(", p. 16; Walter P. Lane, "), _c('i', [_vm._v("The Adventures and Recollections of General Walter P. Lane")]), _vm._v(" …, p. 83.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt46ch1",
      "id": "nt46ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("46")])])])]), _vm._v(" Rose, "), _c('i', [_vm._v("Ross’ Texas Brigade")]), _vm._v(", p. 18; Dallas (Texas) "), _c('i', [_vm._v("Herald")]), _vm._v(", June 19, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt47ch1",
      "id": "nt47ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("47")])])])]), _vm._v(" Barron, "), _c('i', [_vm._v("Lone Star Defenders")]), _vm._v(", p. 20.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt48ch1",
      "id": "nt48ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("48")])])])]), _vm._v(" Ben McCulloch to L. P. Walker, July 30, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 622–623; Sterling Price to C. F. Jackson, August 11, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 99; and Rose, "), _c('i', [_vm._v("Gen. Ben McCulloch")]), _vm._v(", p. 135.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt49ch1",
      "id": "nt49ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("49")])])])]), _vm._v(" McCulloch to S. Cooper, August 12, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 104; Price to Jackson, August 11, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 98–99.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt50ch1",
      "id": "nt50ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("50")])])])]), _vm._v(" J. M. Schofield’s report, August 20, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 59.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt51ch1",
      "id": "nt51ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("51")])])])]), _vm._v(" McCulloch to Walker, August 12, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 105.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt52ch1",
      "id": "nt52ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("52")])])])]), _vm._v(" Schofield’s report, August 20, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 60–61.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt53ch1",
      "id": "nt53ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("53")])])])]), _vm._v(" McCulloch to Walker, August 20, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 105–107. Yankee casualties were 223 killed, 721 wounded, and 291 captured and missing. Confederate losses were 265 killed, 800 wounded, and 30 captured and missing.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt54ch1",
      "id": "nt54ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("54")])])])]), _vm._v(" Proclamation to the Cherokee People, May 17, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. XIII, 489–490.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt55ch1",
      "id": "nt55ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("55")])])])]), _vm._v(" An excellent discussion of Pike’s dealings in the Indian Territory may be found in Walter Lee Brown, “Albert Pike, 1809–1891,” pp. 540–600. The treaties Pike negotiated with Indian tribes are in "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. IV, vol. 1, 445–466, 513–527, 542–554, 636–666, 669–687.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt56ch1",
      "id": "nt56ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("56")])])])]), _vm._v(" Ben McCulloch to L. P. Walker, June 27, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. III, 595–596, 600.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt57ch1",
      "id": "nt57ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("57")])])])]), _vm._v(" Proclamation of Chief Hudson, June 14, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 593–594.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt58ch1",
      "id": "nt58ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("58")])])])]), _vm._v(" Abstract from Monthly Report of McCulloch’s Brigade, Provisional Forces, C. S. Army, August 31, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 690.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt59ch1",
      "id": "nt59ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("59")])])])]), _vm._v(" Ben McCulloch to John Ross, September 1, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 691; McCulloch to John Drew, September 1, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v(".; and McCulloch to L. P. Walker, September 2, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 692.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt60ch1",
      "id": "nt60ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("60")])])])]), _vm._v(" Edward Everett Dale and Gaston Litton, eds., "), _c('i', [_vm._v("Cherokee Cavaliers: Forty Years of Cherokee History as Told in the Correspondence of the Ridge-Watie-Boudinot Family")]), _vm._v(", pp. 100–101; Mabel W. Anderson, "), _c('i', [_vm._v("Life of General Stand Watie: The Only Indian Brigadier General of the Confederate Army and the Last General to Surrender")]), _vm._v(", p. 14.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt61ch1",
      "id": "nt61ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("61")])])])]), _vm._v(" Dale and Litton, "), _c('i', [_vm._v("Cherokee Cavaliers")]), _vm._v(", pp. 106–107.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt62ch1",
      "id": "nt62ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("62")])])])]), _vm._v(" Ben McCulloch to L. P. Walker, September 2, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 692.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt63ch1",
      "id": "nt63ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("63")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., ser. IV, vol. 1, 669–687.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt64ch1",
      "id": "nt64ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("64")])])])]), _vm._v(" Ben McCulloch to John Drew, September 1, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. III, 690; Annie H. Abel, "), _c('i', [_vm._v("The American Indian as Slaveholder and Secessionist")]), _vm._v("; Volume I of "), _c('i', [_vm._v("The Slaveholding Indians")]), _vm._v(", pp. 240–253.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt65ch1",
      "id": "nt65ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("65")])])])]), _vm._v(" Pike to J. P. Benjamin, November 27, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. VIII, 697; Abel, "), _c('i', [_vm._v("American Indian as Slaveholder and Secessionist")]), _vm._v(", pp. 252–253.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt66ch1",
      "id": "nt66ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("66")])])])]), _vm._v(" Captain George H. Pettis, U.S.V., “The Confederate Invasion of New Mexico and Arizona,” in "), _c('i', [_vm._v("Battles and Leaders of the Civil War")]), _vm._v(", II, 109; Martin H. Hall, “The Formation of Sibley’s Brigade and the March to New Mexico,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", LXI (January, 1958), 384.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt67ch1",
      "id": "nt67ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("67")])])])]), _vm._v(" S. Cooper to H. H. Sibley, July 8, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. IV, 93; L. P. Walker to Edward Clark, July 8, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 93.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt68ch1",
      "id": "nt68ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("68")])])])]), _vm._v(" Special Orders No. 123, August 14, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., p. 98.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt69ch1",
      "id": "nt69ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("69")])])])]), _vm._v(" Texas Adjutant General, "), _c('i', [_vm._v("Report, November, 1861")]), _vm._v(", p. 4.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt70ch1",
      "id": "nt70ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("70")])])])]), _vm._v(" Bellville (Texas) "), _c('i', [_vm._v("Countryman")]), _vm._v(", September 4, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt71ch1",
      "id": "nt71ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("71")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., September 11, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt72ch1",
      "id": "nt72ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("72")])])])]), _vm._v(" The best account of the invasion is Martin H. Hall, "), _c('i', [_vm._v("Sibley’s New Mexico Campaign")]), _vm._v(". See also Ray C. Colton, "), _c('i', [_vm._v("The Civil War in the Western Territories")]), _vm._v(", pp. 13–99; and Robert Lee Kerby, "), _c('i', [_vm._v("The Confederate Invasion of New Mexico and Arizona")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt73ch1",
      "id": "nt73ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("73")])])])]), _vm._v(" Throughout the year 1861, requests for troops from Texas, Louisiana, and Arkansas to be sent east of the Mississippi specified infantry. In April, 1861, the War Department had asked for 8,000 infantry from Texas and 8,000 from Louisiana, and in September requested 10,000 from Arkansas. Thus, most of the cavalry raised in 1861 remained in the Trans-Mississippi until ordered later in the war to cross east of the River. L. P. Walker to Edward Clark, April 8, 16, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. III, vol. V, 692; Walker to T. O. Moore, April 8, 16, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v(".; and A. S. Johnston to H. M. Rector, September 22, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. IV, 422.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt74ch1",
      "id": "nt74ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("74")])])])]), _vm._v(" Harrell, “Arkansas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", X, 294. The regiment served east of the Mississippi until 1864, when it came back to Arkansas and served in Cabell’s, Gano’s, and Dockery’s brigades, and in Fagan’s division of Price’s cavalry corps.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt75ch1",
      "id": "nt75ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("75")])])])]), _vm._v(" Mrs. Kate Scurry Terrell, “Terry’s Texas Rangers,” in "), _c('i', [_vm._v("Comprehensive History of Texas")]), _vm._v(", II, 682. The best single history of Terry’s Texas Rangers is Leonidas B. Giles, "), _c('i', [_vm._v("Terry’s Texas Rangers")]), _vm._v(", which is largely reminiscent. Giles, who was a member of Company D, relates the story of the men of the regiment —“their campaigns, their marches, battles, hardships”—throughout the war. Another good account, but less interesting, is Blackburn. “Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII, 38–78, 143–179. Valuable information of the regiment after it left the Trans-Mississippi in November, 1861, may be found in the John W. Hill Letters, 1861–1865, and in the Robert Franklin Bunting Papers. Both of these collections are located in the Archives Collection of the Library of the University of Texas. The Bunting Papers include the Diary of Frank Bunting, 1861–1863, and the Letters of Robert Franklin Bunting, November 9, 1861, to 1865. The letters are preserved as a typescript copy of Bunting’s war correspondence to the Houston "), _c('i', [_vm._v("Daily Telegraph")]), _vm._v(" and the San Antonio "), _c('i', [_vm._v("Herald")]), _vm._v(". Bunting was chaplain for the Rangers. A good, terse account of the celebrated regiment is Lester N. Fitzhugh, "), _c('i', [_vm._v("Terry’s Texas Rangers, 8th Texas Cavalry, C.S.A.: An Address")]), _vm._v(" … "), _c('i', [_vm._v("before the Houston Civil War Round Table")]), _vm._v(", March 21, 1958.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt76ch1",
      "id": "nt76ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("76")])])])]), _vm._v(" Blackburn, “Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII, 41.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt77ch1",
      "id": "nt77ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("77")])])])]), _vm._v(" Bellville (Texas) "), _c('i', [_vm._v("Countryman")]), _vm._v(", August 21, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt78ch1",
      "id": "nt78ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("78")])])])]), _vm._v(" D. H. Combs to L. B. Giles, January 5 [year not shown], in Giles, "), _c('i', [_vm._v("Terry’s Texas Rangers")]), _vm._v(", p. 7.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt79ch1",
      "id": "nt79ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("79")])])])]), _vm._v(" Giles, "), _c('i', [_vm._v("Terry’s Texas Rangers")]), _vm._v(", pp. 13–15.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt80ch1",
      "id": "nt80ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("80")])])])]), _vm._v(" Jno. Claiborne, comp., Muster Rolls of Terry’s Texas Rangers, Reunion in Galveston, February 20, 1882, in the Archives Collection of the Library of the University of Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt81ch1",
      "id": "nt81ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("81")])])])]), _vm._v(" Blackburn, “Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII, 42.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt82ch1",
      "id": "nt82ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("82")])])])]), _vm._v(" Giles, "), _c('i', [_vm._v("Terry’s Texas Rangers")]), _vm._v(", pp. 13–14.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt83ch1",
      "id": "nt83ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("83")])])])]), _vm._v(" Printed from Houston (Texas) "), _c('i', [_vm._v("Telegraph")]), _vm._v(", Bellville (Texas) "), _c('i', [_vm._v("Countryman")]), _vm._v(", September 18, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt84ch1",
      "id": "nt84ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("84")])])])]), _vm._v(" Giles, "), _c('i', [_vm._v("Terry’s Texas Rangers")]), _vm._v(", pp. 13–14; Blackburn, “Terry Rangers,” "), _c('i', [_vm._v("Southwestern Historical Quarterly")]), _vm._v(", XXII, 42.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt85ch1",
      "id": "nt85ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("85")])])])]), _vm._v(" New Orleans (Louisiana) "), _c('i', [_vm._v("Daily Crescent")]), _vm._v(", November 18, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt86ch1",
      "id": "nt86ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("86")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., September 28, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt87ch1",
      "id": "nt87ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("87")])])])]), _vm._v(" Plaquemine (Louisiana) "), _c('i', [_vm._v("Gazette")]), _vm._v(", November 2, 1861; New Orleans (Louisiana) "), _c('i', [_vm._v("Daily Crescent")]), _vm._v(", November 4, 16, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt88ch1",
      "id": "nt88ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("88")])])])]), _vm._v(" "), _c('i', [_vm._v("Ibid")]), _vm._v("., October 11, 1861.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt89ch1",
      "id": "nt89ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("89")])])])]), _vm._v(" Governor Clark of Texas estimated that by November 1, 1861, the state had raised over 20,000 men, cavalry and infantry (mostly horsemen), for the Confederacy. (Texas) "), _c('i', [_vm._v("Governor’s Message, November 1, 1861")]), _vm._v(", p. 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt90ch1",
      "id": "nt90ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("90")])])])]), _vm._v(" Wooten, "), _c('i', [_vm._v("Comprehensive History of Texas")]), _vm._v(", II, 572–630; Roberts, “Texas,” "), _c('i', [_vm._v("Confederate Military History")]), _vm._v(", XI, 45–58; Texas Adjutant General, "), _c('i', [_vm._v("Report, November, 1861")]), _vm._v(", pp. 1–3; Lester N. Fitzhugh, comp., "), _c('i', [_vm._v("Texas Batteries, Battalions, Regiments, Commanders and Field Officers Confederate States Army, 1861–1865")]), _vm._v(", pp. 23, 25–28.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt91ch1",
      "id": "nt91ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("91")])])])]), _vm._v(" Articles of Transfer of Arkansas Volunteers to the Confederate Service, July 15, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. I, vol. III, 609–610; Ben McCulloch to L. P. Walker, July 18, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 611–612; Abstract of Monthly Troop Returns, August and October, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., pp. 690, 730; Hempstead, "), _c('i', [_vm._v("Pictorial History of Arkansas")]), _vm._v(", pp. 363–427.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt92ch1",
      "id": "nt92ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("92")])])])]), _vm._v(" Statement of Organized Confederate Units, September, 1861, "), _c('i', [_vm._v("Official Records")]), _vm._v(", ser. IV, vol. I, 628; McCulloch to Walker, July 18, 1861, "), _c('i', [_vm._v("ibid")]), _vm._v("., ser. I, vol. III, 611–612; Louisiana Adjutant General, "), _c('i', [_vm._v("Annual Report, 1891")]), _vm._v(", pp. 12–34; Andrew B. Booth, comp., "), _c('i', [_vm._v("Records of Louisiana Confederate Soldiers and Louisiana Confederate Commands")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/ch01#rnt93ch1",
      "id": "nt93ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("93")])])])]), _vm._v(" (Texas) "), _c('i', [_vm._v("Governor’s Message, November 1, 1861")]), _vm._v(", pp. 7–10; Texas Adjutant General, "), _c('i', [_vm._v("Report, November, 1861")]), _vm._v(", p. 1; Roberts, “Texas,” "), _c('i', [_vm._v("Confederate Military-History")]), _vm._v(", XI, 56–57.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716af6fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 90
// module chunks = 0